//正常返回
export const buildTeam = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": {
			"actChannel": "ABCDEFTEST",
			"createTime": 1539758884335,
			"markId": "852860be7eedf8b5086de125229b48cdfc0d00d4de6b967a04e1853a495dfff0",
			"rewardStatus": 0,
			"status": 1,
			"actCode": "6B345EF788",
			"ext": "{\"nickName\":\"谁也治不了\",\"end_time\":\"2018-10-18 00:00:00\",\"photo\":\"https://storage.360buyimg.com/i.imageUpload/cbadd2b2d6ceb2bbc1cb31353334383532373330323735_big.jpg\"}",
			"pin": "谁也治不了",
			"identification": "NoNewApp"
		},
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}
// 如果活动不存在
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "10001",
// 		"msg": "活动不存在",
// 		"success": false
// 	}
// }
// 存在存活团返回存活团
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"data": {
// 			"actChannel": "ABCDEFTEST",
// 			"createTime": 1539758884335,
// 			"markId": "852860be7eedf8b5086de125229b48cdfc0d00d4de6b967a04e1853a495dfff0",
// 			"rewardStatus": 0,
// 			"status": 1,
// 			"actCode": "6B345EF788",
// 			"ext": "{\"end_time\":\"2018-10-18 00:00:00\"}",
// 			"pin": "谁也治不了",
// 			"identification": "NoNewApp"
// 		},
// 		"code": "10014zt",
// 		"msg": "不展示",
// 		"success": false
// 	}
// }
// 活动时间结束
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "10004",
// 		"msg": "活动已结束",
// 		"success": false
// 	}
// }

export const joinBuildTeam = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": {
			"actChannel": "ABCDEFTEST",
			"createTime": 1539759384890,
			"rewardStatus": 0,
			"rewardName": "B端奖励01",
			"buildTeamPin": "谁也治不了",
			"actCode": "6B345EF788",
			"rewardType": "2",
			"pin": "谁也治不了",
			"identification": "NoNewApp",
			"rewardAmount": 100
		},
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}

export const isBuilder = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"code": "00000zt",
		"msg": "团员",
		"success": false
	}
}
//
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "00000zt",
// 		"msg": "团员",
// 		"success": false
// 	}
// }

export const getJoinList = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": [
			{
				"actChannel": "ABCDEFTEST",
				"createTime": 1539759594000,
				"rewardName": "C端奖励01",
				"updateTime": 1539764563000,
				"actCode": "6B345EF788",
				"rewardType": "2",
				"ext": "{\"nickName\":\"之***k\",\"photo\":\"https://storage.360buyimg.com/i.imageUpload/6a6b34313531313637323231353137393133353134323337_big.jpg\"}",
				"pin": "jk415116722",
				"identification": "NoNewApp",
				"rewardAmount": 1
			},
		],
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}

export const getTeamLeaderInfo = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": {
			"actChannel": "ABCDEFTEST",
			"createTime": 1539758884335,
			"rewardStatus": 0,
			"status": 1,
			"actCode": "6B345EF788",
			"ext": "{\"differ\":\"3\",\"nickName\":\"谁***了\",\"end_time\":\"2018-10-18 00:00:00\",\"daojishi\":\"21393766\",\"photo\":\"https://storage.360buyimg.com/i.imageUpload/cbadd2b2d6ceb2bbc1cb31353334383532373330323735_big.jpg\"}",
			"pin": "谁也治不了",
			"identification": "NoNewApp"
		},
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}

export const isBuildTeam = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"code": "00000zt",
		"msg": "未超过建团数量",
		"success": true
	}
}

//属于该团
export const isUserBeloneTeam = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}
// 不属于该团
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "10016zt",
// 		"msg": "出错啦，请稍后再试",
// 		"success": false
// 	}
// }

export const getCouponList = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": [
			{
				"actChannel": "ABCDEFTEST",
				"createTime": 1539759384000,
				"rewardStatus": 2,
				"rewardName": "B端奖励01",
				"buildTeamPin": "谁也治不了",
				"updateTime": 1539762934000,
				"actCode": "6B345EF788",
				"rewardType": "2",
				"pin": "谁也治不了",
				"identification": "NoNewApp",
				"rewardAmount": 100
			}
		],
		"code": "00000zt",
		"msg": "成功",
		"success": true
	}
}

export const getLuckyRankingList = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"data": [
			{
				"createTime": 1539759384000,
				"dataDimension": 1,
				"rewardAmount": 100,
				"modifyTime": 1539762934000,
				"tbIndex": "",
				"extParam": {
					"tagBig": "nowBig",
					"photo": "https://storage.360buyimg.com/i.imageUpload/cbadd2b2d6ceb2bbc1cb31353334383532373330323735_big.jpg",
					"nickName": "谁***了"
				}
			},
			{
				"createTime": 1539759594000,
				"dataDimension": 1,
				"rewardAmount": 1,
				"modifyTime": 1539764563000,
				"tbIndex": "",
				"extParam": {
					"photo": "https://storage.360buyimg.com/i.imageUpload/6a6b34313531313637323231353137393133353134323337_big.jpg",
					"nickName": "之***k"
				}
			}
		],
		"code": "00",
		"msg": "",
		"success": true
	}
}

// 领取成功
export const sendReward = {
	"resultCode": 0,
	"resultMsg": "操作成功",
	"resultData": {
		"code": "00000zt",
		"msg": "用户领奖成功",
		"success": true
	}
}
// 重复领取
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "10011zt",
// 		"msg": "您已经领取过了，请勿重复领取",
// 		"success": false
// 	}
// }
// 领奖出错
// {
// 	"resultCode": 0,
// 	"resultMsg": "操作成功",
// 	"resultData": {
// 		"code": "10010zt",
// 		"msg": "出错啦，请稍后再试",
// 		"success": false
// 	}
// }



// WEBPACK FOOTER //
// ./src/api/mock.js